import { createRoutine, promisifyRoutine } from 'redux-saga-routines'

export const recommendJob = createRoutine('candidate/RECOMMEND_JOB')
export const recommendJobPromiseCreator = promisifyRoutine(recommendJob)
